'use client';
import { ChevronDown, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export function MobileCategoriesDialog({
  categories = [],
  selectedCategory = '',
  onSelectCategory,
  isOpen,
  onClose,
}) {
  return (
    <>
      {/* Overlay */}
      <div
        className={cn(
          'fixed inset-0 bg-black/50 z-40 transition-opacity md:hidden',
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
      />

      {/* Slide-out dialog */}
      <div
        className={cn(
          'fixed left-0 top-0 bottom-0 w-64 bg-[#121212] text-gray-300 z-50 transform transition-transform md:hidden',
          isOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-800">
          <h2 className="font-medium">Categories</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-800"
          >
            <X size={18} />
          </button>
        </div>

        <div className="p-4">
          <div className="flex items-center gap-2 py-2 px-3 hover:bg-gray-800 rounded-md cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-layers"
            >
              <path
                key="path1"
                d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
              />
              <path
                key="path2"
                d="m22 12.92-8.58 3.92a2 2 0 0 1-1.66 0L2.99 13.01"
              />
              <path
                key="path3"
                d="m22 17.92-8.58 3.92a2 2 0 0 1-1.66 0L2.99 18.01"
              />
            </svg>
            <span className="font-medium">Topics</span>
          </div>
        </div>

        <div className="mt-2 px-4">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-1 text-sm text-gray-400">
              <ChevronDown className="w-4 h-4" />
              <span className="uppercase tracking-wide">CATEGORIES</span>
            </div>
          </div>

          <ul className="space-y-1">
            <li key="all-categories">
              <button
                onClick={() => {
                  onSelectCategory('');
                  onClose();
                }}
                className={`w-full text-left py-1 px-3 rounded-md flex items-center gap-2 hover:bg-gray-800 ${
                  selectedCategory === '' ? 'bg-gray-800' : ''
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-list"
                >
                  <line key="line1" x1="8" x2="21" y1="6" y2="6" />
                  <line key="line2" x1="8" x2="21" y1="12" y2="12" />
                  <line key="line3" x1="8" x2="21" y1="18" y2="18" />
                  <line key="line4" x1="3" x2="3" y1="6" y2="6" />
                  <line key="line5" x1="3" x2="3" y1="12" y2="12" />
                  <line key="line6" x1="3" x2="3" y1="18" y2="18" />
                </svg>
                <span>All categories</span>
              </button>
            </li>

            {categories.map((category, index) => (
              <li key={category.slug || `category-${index}`}>
                <button
                  onClick={() => {
                    onSelectCategory(category.slug);
                    onClose();
                  }}
                  className={`w-full text-left py-1 px-3 rounded-md flex items-center gap-2 hover:bg-gray-800 ${
                    selectedCategory === category.slug ? 'bg-gray-800' : ''
                  }`}
                >
                  <span
                    className="w-3 h-3 rounded-sm"
                    style={{ backgroundColor: category.color || '#3B82F6' }}
                  ></span>
                  <span>{category.name}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
